import React, { Component } from "react";
import { connect } from "react-redux";
import { localizedTranslate } from "assets/localization";
import {
  getEmailTemplate,
  getInvalidateInterviewEmailTemplate,
} from "store/editSession/editSessionActions";
import ExampleEmail from "components/ExampleEmail";
import InvalidateInterviewEmail from "components/InvalidateInterviewEmail";
import { Spinner } from "@blueprintjs/core";

import "less/scheduler/edit-session-modal.less";

class EditSessionView extends Component {
  state = {
    message: "",
  };

  getHeaderText = (action) =>
    action === "cancel"
      ? "Email participant and moderators to cancel this interview."
      : "Email participant to request a new date and time.";

  handleMessage = (event) => {
    const message = event.target.value;
    this.setState({ message });
  };

  forReschedule = this.props.chosenAction === "reschedule";
  addLink = false;
  editLink = false;

  componentDidMount() {
    if (this.props.chosenAction === "reschedule" && !this.props.fromManageEdit && !this.props.fromManageEditCancel) {
      this.props.getInvalidateInterviewEmailTemplate(
        this.props?.timeSlot?.projectId || this.props?.event?.timeslotId
      );
    } else {
      this.props.getEmailTemplate(
       this.props?.timeSlot?.projectId || this.props?.event?.timeslotId,
        this.forReschedule || this.props.fromManageEdit,
        this.addLink,
        this.editLink,
        undefined,
        undefined,
        this.props.invalidateReschedule && !this.props.fromManageEditCancel
      );
    }
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = () => {
      return;
    };
  }

  componentDidUpdate(prevProps) {
    // No-op: remove debug logs after verification
  }

  render() {
    return (
      <div className="edit-session-modal-content">
        <div className="edit-session-body">
          <h4 className="header">
            {this.getHeaderText(this.props.chosenAction)}
          </h4>
          <p className="sub-header">{this.props.t("edit.session.message")}</p>
          <div className="example-email">
            {this.props.isSubmitting ? (
              <Spinner intent="primary" />
            ) : this.props.exampleEmail && this.props.exampleEmail.__html ? (
              this.props.chosenAction === "reschedule" ? (
                <InvalidateInterviewEmail
                  exampleEmail={this.props.exampleEmail}
                />
              ) : (
                <ExampleEmail exampleEmail={this.props.exampleEmail} />
              )
            ) : (
              <div className="template-load-error">Unable to load preview.</div>
            )}
          </div>
          <div className="what-happens-next">
            <strong>What happens next?</strong>
            <p>
              {this.props.chosenAction === "cancel"
                ? this.props.t("cancel.interview.message")
                : this.props.t("reschedule.interview.message")}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  t: localizedTranslate("en", state.translations.en_us),
  exampleEmail: state.editSession.exampleEmail,
  isSubmitting: state.editSession.isSubmitting,
  templateReceived: state.editSession.templateReceived,
});

const mapDispatch = {
  getEmailTemplate,
  getInvalidateInterviewEmailTemplate,
};

export default connect(mapState, mapDispatch)(EditSessionView);
